import ms from 'ms';
import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { fetchStreamIdIfNeeded, getStreamStatus } from '@/redux/modules/video';

/**
 * Polls /api/stream-status for a catalog until a streamId is available.
 * Replaces the polling that was baked into caterwaul's AuctionVideo.
 */
export const useStreamIdPolling = (catalogId: number) => {
    const dispatch = useAppDispatch();
    const { streamId } = useAppSelector((state) => getStreamStatus(state, catalogId));

    useEffect(() => {
        if (streamId) {
            return;
        }
        const interval = setInterval(() => {
            dispatch(fetchStreamIdIfNeeded(catalogId));
        }, ms('1s'));
        return () => {
            clearInterval(interval);
        };
    }, [catalogId, dispatch, streamId]);

    return streamId;
};
